import styled from 'styled-components';

export const BackButton = styled.div`
	cursor: pointer;
	position: absolute;
	top: 10px;
	right: 10px;
	height: 40px;
	line-height: 40px;
	color: ${(p) => p.theme.color.textColor};
	z-index: 1000;
	text-align: center;

	.icon {
		font-size: 0.875rem;
		margin-left: 5px;
	}
`;
